import { render, staticRenderFns } from "./tournamentHero.vue?vue&type=template&id=2345ce77&scoped=true&"
import script from "./tournamentHero.vue?vue&type=script&lang=js&"
export * from "./tournamentHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2345ce77",
  null
  
)

export default component.exports